"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.InvestorsTableEntity = exports.getDocumentsInvestor = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var fields_1 = require("../../fields");
var document_factory_1 = require("./document-factory");
var getTable = function (prismicDoc, logger) {
    var tableLines = prismicDoc.data.investors_table_lines_items;
    var table = tableLines === null || tableLines === void 0 ? void 0 : tableLines.map(function (item) { return toTableLine(item, logger); }).filter(Boolean);
    if (!(table === null || table === void 0 ? void 0 : table.length)) {
        return undefined;
    }
    return table;
};
var toTableLine = function (data, logger) {
    var label = logger.required(fields_1.toText(data.label));
    var value = logger.required(fields_1.toText(data.value));
    if (!label || !value) {
        return undefined;
    }
    return { label: label, value: value };
};
var getDocumentsInvestor = function (prismicDoc, logger) {
    var tableDocuments = prismicDoc.data.investors_table_documents_items;
    var documents = tableDocuments === null || tableDocuments === void 0 ? void 0 : tableDocuments.map(function (item) { return toDocAndDateInvestor(item, logger); }).filter(Boolean);
    if (!(documents === null || documents === void 0 ? void 0 : documents.length)) {
        return undefined;
    }
    return documents;
};
exports.getDocumentsInvestor = getDocumentsInvestor;
var toDocAndDateInvestor = function (data, logger) {
    var dateDocument = fields_1.toText(data.doc_date);
    var title = logger.required(fields_1.toText(data.doc_title));
    var link = logger.required(fields_1.toMediaLink(data.doc_link, logger));
    if (!title || !link) {
        return undefined;
    }
    return { dateDocument: dateDocument, document: { title: title, link: link } };
};
exports.InvestorsTableEntity = document_factory_1.documentFactory(types_1.DocumentType.INVESTORS_TABLE, function (prismicDoc, normalizedDoc, logger) {
    var table = getTable(prismicDoc, logger);
    var documents = exports.getDocumentsInvestor(prismicDoc, logger);
    return utils_1.compact(__assign(__assign({}, normalizedDoc), { table: table,
        documents: documents }));
});
//# sourceMappingURL=investors-table.js.map